import { render, staticRenderFns } from "./upload-2.vue?vue&type=template&id=cd2eed70&"
import script from "./upload-2.vue?vue&type=script&lang=js&"
export * from "./upload-2.vue?vue&type=script&lang=js&"
import style0 from "./upload-2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../_vue-loader@15.7.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports